import axios from 'axios';
import { WRITE_TIMEOUT_MS } from '../../misc/requests.js';
import { resourceError } from '../../misc/request-errors.js';

const API_URL = process.env.VUE_APP_API_URL + '/reviews';
const state = {
    review: [],
};
const getters = {
    review: (state) => state.review,
};
const actions = {
    async createReview({ commit }, data) {
        const response = await axios.post(API_URL, data, { timeout: WRITE_TIMEOUT_MS });
        if (String(response.data?.booking_id) !== String(data.booking_id)) throw resourceError('INVALID_RESPONSE');
        commit('setReview', response.data);
    },
};
const mutations = {
    setReview: (state, review) => state.review = review,
};

export default {
    state,
    getters,
    actions,
    mutations,
}
